export const locale = {
  lang: 'en',
  data: {
    NEW_COMPANY_DIALOG: {
      NEW: 'New',
      CANCEL: 'Cancel',
      SAVE: 'Save',
      CONTACT_DATA: 'Contact Data',
      COMPANY: {
        BUSINESS_NAME: 'Business Name',
        TAX_CODE_PREFIX: 'Country',
        TAX_CODE: 'Tax code',
        LAST_NAME: 'Last name',
        FIRST_NAME: 'First name',
        PHONE: 'Phone',
        EMAIL: 'Email',
        NOTE: 'Notes',
      },
      ADDRESS: {
        TITLE: 'Title',
        ADDRESS_1: 'Street',
        CITY: 'City',
        STATE: 'State',
        ZIP: 'Zip',
        COUNTRY: 'Country',
        PHONE: 'Phone',
        FAX: 'Fax',
      },
      ERROR: {
        REQUIRED: 'Required',
        WRONG_FORMAT: 'Wrong format',
        TAX_CODE_ALREADY_USED: 'Tax code already used',
        INVALID_EMAIL: 'Invalid email',
        SAVE_ERROR: 'Error: company not saved... Try again!',
      },
    },
  },
};
